export const getFloatValue = value => {
  const tmpVal = String(value).replace(/,/g, '.');
  return isNaN(tmpVal) ? 0 : parseFloat(tmpVal);
}